/** Neto efectivo de línea tras % descuento de ítem. */
export function netoEfectivoLinea(
  precioLista: number | null | undefined,
  porcDesc: number | null | undefined,
): number {
  const lista = Number(precioLista) || 0;
  const pct = Number(porcDesc) || 0;
  return lista - (lista * pct) / 100;
}

/**
 * Valida que el neto efectivo no quede por debajo del precio mínimo del artículo.
 * Devuelve mensaje de error o null si es válido / no aplica.
 */
export function validarPrecioMinimoLinea(params: {
  codigoArticulo?: string | null;
  precioLista: number | null | undefined;
  porcDesc?: number | null | undefined;
  /** Neto ya con desc. de ítem (si se informa, tiene prioridad sobre lista/%). */
  netoEfectivo?: number | null | undefined;
  precioMinimo?: number | null | undefined;
}): string | null {
  const min = params.precioMinimo != null ? Number(params.precioMinimo) : null;
  if (min == null || Number.isNaN(min) || min <= 0) return null;

  const neto =
    params.netoEfectivo != null && !Number.isNaN(Number(params.netoEfectivo))
      ? Number(params.netoEfectivo)
      : netoEfectivoLinea(params.precioLista, params.porcDesc);

  if (neto + 0.0001 >= min) return null;

  const codigo = (params.codigoArticulo ?? '').trim() || 'artículo';
  const fmt = (n: number) =>
    n.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 4 });
  return `El artículo '${codigo}' tiene un precio neto (${fmt(neto)}) inferior al mínimo permitido (${fmt(min)}).`;
}

export function primerErrorPrecioMinimoLineas(
  lineas: ReadonlyArray<{
    codigoArticulo?: string | null;
    precioUnitario?: number | null;
    descuento?: number | null;
    precioMinimo?: number | null;
  }>,
): string | null {
  for (const l of lineas) {
    const codigo = (l.codigoArticulo ?? '').trim();
    if (!codigo) continue;
    const err = validarPrecioMinimoLinea({
      codigoArticulo: codigo,
      precioLista: l.precioUnitario,
      porcDesc: l.descuento,
      precioMinimo: l.precioMinimo,
    });
    if (err) return err;
  }
  return null;
}
